import React, { useEffect, useMemo, useRef, useState } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import Card from '../components/Card/Card'
import { constants } from '../redux/callTakers/actions'
import { commonConstants } from '../redux/common/actions'
import ReactTable from 'react-table'
import { getFormattedUser } from '../services/auth'
//import SweetAlert from 'react-bootstrap-sweetalert'
import Button from '../components/CustomButton/CustomButton.jsx'
import NotificationSystem from 'react-notification-system'
import { style as notificationStyling } from '../variables/Variables'
import CustomReactTablePagination from './Components/CustomReactTablePagination'
import { CSVLink } from "react-csv"
import { Row, Col, Modal } from 'react-bootstrap'
import moment from 'moment-timezone'

const { FETCH_ALL_CALL_TAKERS } = constants
const { REQUEST } = commonConstants
const headerStyle = { textAlign: 'center', fontWeight: 'bold', color: '#333333' }
const cellStyle = { textAlign: 'center' }
// TODO: If we add any additional "system users" to production this array needs to be updated
const systemUsernames = ['alex', 'azorkin', 'api_user', 'ben', 'dan', 'fgraf', 'hfgraf', 'pfgraf', 'tfgraf', 'ssamuels']

const CallTakers = ({ history }) => {
  const { callTakers, loading, error, success } = useSelector(state => state.callTakers)
  const dispatch = useDispatch()
  const notificationSystem = useRef()
  const [alert, ] = useState(null)
  const [_notificationSystem, setNotificationSystem] = useState({})

  // initial page fetch
  useEffect(() => {
    dispatch({ type: FETCH_ALL_CALL_TAKERS + REQUEST, payload: { enabled: true } })
    setNotificationSystem(notificationSystem)
    return () => {}
  }, [])
  // retrieve admin privilege/user if applicable
  const [hasAdmin, setHasAdmin] = useState(false)
  const [hasHrAdmin, setHasHrAdmin] = useState(false)
  const [, setSelectedScheduleUser] = useState(null)
  const [userCard, setUserCard] = useState({ isShowing: false, info: {}, hasAdmin: hasAdmin })

  const csvReportFileName = `Call Taker Roaster ${moment().format('MM-DD-YYYY')}`

  useEffect(() => {
    const getAuth = async() => {
      const user = await getFormattedUser()
      const hasAdmin = user && user.roles && user.roles.includes('SuperAdmin')
      setHasAdmin(hasAdmin)
      const hasHrAdmin = user && user.roles && user.roles.includes('HrAdmin')
      setHasHrAdmin(hasHrAdmin)
      setSelectedScheduleUser(user.id)
    }
    getAuth().then()
  }, [])
  // handle ajax side effects
  useEffect(() => {
    const notificationSystem = _notificationSystem.current
    if (notificationSystem && success.message) { notificationSystem.addNotification({ message: success.message, level: 'info', position: 'tc' }) }
    if (notificationSystem && error.message) { notificationSystem.addNotification({ message: error.message, level: 'error', position: 'tc' }) }
    return () => {}
  }, [success.message, error.message])
  // handle onClick row navigation
  const [historyNavigation, ] = useState({ enabled: false, id: null })
  useEffect(() => {
    if (historyNavigation.enabled) {
      history.push(`/admin/user/${historyNavigation.id}?readOnly=true`)
    }
    return () => {}
  },[historyNavigation.enabled])
  // handle scroll to top for notifications
  useEffect(() => {
    // THIS IS SCREWY - Desktop works fine, Mobile scrolls to top quickly then back to original position - 2x fixed this
    document.getElementById('top-of-the-form-to-ya').scrollIntoView(true)
    document.getElementById('top-of-the-form-to-ya').scrollIntoView(true)
    return () => {}
  }, [success.message, error.message])

  const columns = [
    { Header: "Id", accessor: "id", show: false },
    {
      Header: "First Name",
      accessor: "firstName",
      style: cellStyle,
      headerStyle,
    },
    {
      Header: "Last Name",
      accessor: "lastName",
      style: cellStyle,
      headerStyle,
    },
    { Header: "Email", accessor: "email", style: cellStyle, headerStyle },
    { Header: "Phone", accessor: "cellPhone", style: cellStyle, headerStyle },
    {
      Header: "Address",
      accessor: "address",
      style: cellStyle,
      headerStyle,
      show: false,
    },
    { Header: "City", accessor: "city", style: cellStyle, headerStyle },
    {
      Header: "State",
      accessor: "location",
      style: cellStyle,
      headerStyle,
    },
    {
      Header: "Zip",
      accessor: "zip",
      style: cellStyle,
      headerStyle,
      show: false,
    },
    {
      Header: "Birthday",
      accessor: "birthday",
      style: cellStyle,
      headerStyle,
      show: hasAdmin || hasHrAdmin,
    },
    {
      Header: "Class #",
      accessor: "classNumber",
      style: cellStyle,
      headerStyle,
    },
  ];

  // const renderDeleteConfirm = (callTakerName, id, dispatch) => {
  //   return setAlert((
  //     <SweetAlert
  //       showCancel
  //       style={{ display: 'block', marginTop: '-100px' }}
  //       title="Confirm Deletion"
  //       onConfirm={() => dispatch({ type: DELETE_CALL_TAKER + REQUEST, payload: { id } }) && setAlert(null) }
  //       onCancel={() => setAlert(null) }
  //       confirmBtnBsStyle="danger"
  //     >
  //       {`Are you sure you want to delete call taker "${callTakerName}"?`}
  //     </SweetAlert>
  //   ))
  // }

  const filterMethod = (filter, row, column) => {
    const id = filter.pivotId || filter.id
    return row[id] !== undefined ? String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase()) : true
  }

  const list = callTakers.map((prop, key) => {
    const birthday =
      prop.birthMonth && prop.birthDay
        ? prop.birthMonth + "/" + prop.birthDay
        : "-";
    return {
      username: prop.username,
      id: prop.id,
      firstName: prop.firstName || "-",
      lastName: prop.lastName || "-",
      classNumber: prop.initialTrainingClass?.number || "-",
      email: prop.email || "-",
      address: prop.address || "-",
      city: prop.city || "-",
      location: prop.location || "-",
      zip: prop.zip || "-",
      cellPhone: prop.cellPhone?.national || "-",
      birthday: birthday,
    };
  });
  const csvList = useMemo(() => {
    return list.filter(l => !systemUsernames.includes(l.username))
  }, [list])

  return (
    <div className="main-content">
      <NotificationSystem
        ref={notificationSystem}
        style={notificationStyling}
      />
      {alert}
      <Card
        content={
          <div>
            {(hasAdmin || hasHrAdmin) && (
              <div>
                {csvList.length > 0 && (
                  <CSVLink data={csvList} filename={csvReportFileName}>
                    <Button round fill>
                      Download Call Taker Roster
                    </Button>
                  </CSVLink>
                )}
              </div>
            )}
            <ReactTable
              PaginationComponent={CustomReactTablePagination}
              showTotalPages={true}
              canNextFromData={false}
              data={list}
              filterable
              columns={columns}
              cursor="default"
              defaultPageSize={100}
              defaultFilterMethod={filterMethod}
              showPaginationBottom
              showPaginationTop
              sortable
              loading={loading.source === FETCH_ALL_CALL_TAKERS}
              className="-striped row-pointer"
              getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row) {
                  return {
                    onClick: (e) => {
                      setUserCard({
                        isShowing: true,
                        info: rowInfo.row,
                        hasAdmin: hasAdmin,
                      });
                    },
                  };
                } else {
                  return {};
                }
              }}
            />
          </div>
        }
      />
      <Modal
        show={userCard.isShowing}
        onHide={() =>
          setUserCard({ isShowing: false, info: {}, hasAdmin: hasAdmin })
        }
      >
        <Modal.Header closeButton>
          <Modal.Title>Call Taker Details</Modal.Title>
          <Modal.Body>
            <Row>
              <Col xs={3}>Name: </Col>
              <Col
                xs={9}
              >{`${userCard.info.firstName} ${userCard.info.lastName}`}</Col>
            </Row>
            <Row>
              <Col xs={3}>Email: </Col>
              <Col xs={9}>{userCard.info.email}</Col>
            </Row>
            <Row>
              <Col xs={3}>Phone: </Col>
              <Col xs={9}>
                <a href={"tel:" + userCard.info.cellPhone}>
                  {userCard.info.cellPhone}
                </a>
              </Col>
            </Row>
            {hasAdmin && (
              <div>
                <Row>
                  <Col xs={3}>Address: </Col>
                  <Col xs={9}>{userCard.info.address}</Col>
                </Row>
                <Row>
                  <Col xs={3}>City: </Col>
                  <Col xs={9}>{userCard.info.city}</Col>
                </Row>
                <Row>
                  <Col xs={3}>State: </Col>
                  <Col xs={9}>{userCard.info.location}</Col>
                </Row>
                <Row>
                  <Col xs={3}>Zip: </Col>
                  <Col xs={9}>{userCard.info.zip}</Col>
                </Row>
                <Row>
                  <Col xs={3}>Birthday: </Col>
                  <Col xs={9}>{userCard.info.birthday}</Col>
                </Row>
                <Row>
                  <Col xs={3}>Class#: </Col>
                  <Col xs={9}>{userCard.info.classNumber}</Col>
                </Row>
              </div>
            )}
          </Modal.Body>
        </Modal.Header>
      </Modal>
    </div>
  );
}

export default CallTakers
